<template>
  <v-row>
    <v-col md="12">
      <v-card flat class="py-4">
        <div class="text-h5 px-3 font-weight-bold text-uppercase pt-4">
          Project
        </div>
        <v-layout class="dashboard-top-button px-3 py-4 overflow-hidden">
          <v-flex
            v-for="(item, index) in dProjectArr"
            :key="index"
            class="mx-4"
          >
            <v-card
              outlined
              :color="`${item.color} lighten-5`"
              :style="`border-color: ${getBgColor(item.color)}!important`"
            >
              <v-card-text>
                <div class="d-flex align-center">
                  <div class="text-h6 fw-500 me-3">{{ item.title }}</div>
                  <v-avatar size="25" small :color="item.iconColor"
                    ><span class="font-size-16 text-white">{{
                      item.value
                    }}</span></v-avatar
                  >
                </div>
                <div class="d-flex align-center">
                  <div
                    :class="`text-h4 font-weight-bold ${item.textColor} mt-1`"
                  >
                    {{ formatMoney(item.amount) }}
                  </div>
                  <v-spacer />
                  <v-icon :size="40" :color="item.iconColor">
                    {{ item.icon }}
                  </v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-col>
    <v-col md="12">
      <v-card flat class="">
        <div class="text-h5 px-3 font-weight-bold text-uppercase pt-4">
          Milestone
        </div>
        <v-layout class="dashboard-top-button px-3 py-4 overflow-hidden">
          <v-flex
            v-for="(item, index) in dProjectMilestoneArr"
            :key="index"
            class="mx-4"
          >
            <v-card
              outlined
              :color="`${item.color} lighten-5`"
              :style="`border-color: ${getBgColor(item.color)}!important`"
            >
              <v-card-text>
                <div class="d-flex align-center">
                  <div class="text-h6 fw-500 me-3">{{ item.title }}</div>
                  <v-avatar size="25" small :color="item.iconColor"
                    ><span class="font-size-16 text-white">{{
                      item.value
                    }}</span></v-avatar
                  >
                </div>

                <!--   <div class="text-h6 fw-500">{{ item.title }}</div> -->
                <div class="d-flex align-center">
                  <div
                    :class="`text-h4 font-weight-bold ${item.textColor} mt-1`"
                  >
                    {{ formatMoney(item.amount) }}
                  </div>
                  <v-spacer />
                  <v-icon :size="40" :color="item.iconColor">
                    {{ item.icon }}
                  </v-icon>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-col>
    <v-col md="12">
      <v-card flat class="px-4 h-100">
        <v-card-text>
          <div class="d-flex align-center">
            <div class="text-h5 font-weight-bold text-uppercase py-4">
              Project Budget
            </div>
            <v-spacer />
            <v-btn
              depressed
              :to="{ name: 'admin.project' }"
              variant="flat"
              text-color="white"
              class="font-weight-bold"
              color="cyan"
            >
              <span class="text-white">View All</span>
            </v-btn>
          </div>

          <div id="chart" class="budget">
            <apexchart
              type="bar"
              height="350"
              :options="budgetchartOptions"
              :series="budgetseries"
            ></apexchart>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
import CommonFunctionMixin from "@/core/lib/common/common.functions.mixin";
import { GET } from "@/core/services/store/request.module";

/* import { filter } from "lodash"; */
/* import moment from "moment"; */
export default {
  name: "ProjectStatus",
  mixins: [CommonFunctionMixin],

  data() {
    return {
      categories: [],
      // Project Budget chart Start data
      budgetseries: [],
      /*   budgetchartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
        },
        colors: ["#008ffb", "#00e396"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },

        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          title: {
            text: "$ (thousands)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      }, */
      // Project Budget chart End data

      projectDurationFilterList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "This Quarter", value: "this_quarter" },
        { text: "This Year", value: "this_year" },
      ],
      projectTypeFilterList: [
        { text: "All Type", value: "all" },
        { text: "Software", value: "software" },
        { text: "Seo", value: "seo" },
      ],
    };
  },
  methods: {
    async getProjectCount() {
      this.pageLoading = true;
      try {
        const response = await this.$store.dispatch(GET, {
          url: "project-graph",
        });

        if (response.data) {
          this.updateChart(
            response.data.data,
            response.data.yAxisTitle,
            response.data.budgetSeries
          );
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
    updateChart(data, yAxisTitle, budgetSeries) {
      this.categories = data.map((item) => [
        item.project_code,
        item.project_title,
      ]);
      this.budgetseries = budgetSeries;
      this.yAxisTitle = yAxisTitle; // Update Y-Axis title dynamically
    },
    setProjectAxisTooltips(chart) {
      const labels = chart.el.querySelectorAll(".apexcharts-xaxis-label");
      labels.forEach((label, index) => {
        const category = this.categories[index];
        const title = label.querySelector("title");
        if (title && Array.isArray(category)) {
          title.textContent = category.filter(Boolean).join(" ");
        }
      });
    },
    getBgColor(color) {
      switch (color) {
        case "cyan":
          return "#00bcd4";
        case "green":
          return "#4CAF50";
        case "red":
          return "#F44336";
        case "blue":
          return "#2196f3";
        case "orange":
          return "#ff9800";
        case "purple":
          return "#9c27b0";
        case "yellow":
          return "#ffeb3b";
        default:
          return "white";
      }
    },
  },
  mounted() {
    this.getProjectCount();
  },
  computed: {
    ...mapGetters([
      "dbEngineers",
      "dProjectArr",
      "dActiveProjectDuration",
      "dActiveProjectType",
      "dActiveProjectUser",
      "dProjectMilestoneArr",
    ]),
    budgetchartOptions() {
      return {
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false },
          events: {
            mounted: (chart) => this.setProjectAxisTooltips(chart),
            updated: (chart) => this.setProjectAxisTooltips(chart),
          },
        },
        colors: ["#008ffb", "#00e396"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.categories, // Dynamic categories from API
          labels: {
            rotate: 0,
            rotateAlways: false,
            style: { fontSize: "12px" },
            formatter: (value) => {
              const truncateLabel = (label) => {
                if (typeof label !== "string" || label.length <= 24) {
                  return label;
                }

                return `${label.substring(0, 21)}...`;
              };

              if (Array.isArray(value)) {
                return value.map(truncateLabel);
              }

              if (typeof value !== "string") {
                return value;
              }

              return truncateLabel(value);
            },
          },
        },
        yaxis: {
          title: {
            text: this.yAxisTitle, // Dynamically update Y-Axis title
          },
        },
        fill: { opacity: 1 },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const category = this.categories[dataPointIndex] || [];
            const [projectCode, projectTitle] = Array.isArray(category)
              ? category
              : ["", category];
            const escapeHtml = (value) =>
              String(value == null ? "" : value).replace(
                /[&<>"']/g,
                (character) =>
                  ({
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': "&quot;",
                    "'": "&#39;",
                  }[character])
              );
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = this.formatMoney(series[seriesIndex][dataPointIndex]);

            return `
              <div style="width: 320px; max-width: calc(100vw - 32px); padding: 8px 10px; white-space: normal; overflow-wrap: anywhere;">
                <div style="font-weight: 600;">${escapeHtml(projectCode)}</div>
                <div style="white-space: normal; overflow-wrap: anywhere;">${escapeHtml(projectTitle)}</div>
                <div style="margin-top: 6px;">${escapeHtml(seriesName)}: ${escapeHtml(value)}</div>
              </div>
            `;
          },
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.project-stats-count {
  tr:not(.no-border) {
    th,
    td {
      padding: 4px 8px;
      // border:1px solid grey
    }
  }
}
.right-graphics {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 100px;
  opacity: 0.3;
}
</style>
